import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";

export const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 50);
        return;
      }
    }
    window.scrollTo({ top: 0 });
  }, [pathname, hash]);
  return null;
};

export const PageShell = ({ children }) => (
  <div className="bg-obsidian min-h-screen">
    <Navbar />
    <main>{children}</main>
    <Footer />
    <FloatingActions />
  </div>
);

export const SectionHeading = ({ overline, title, children, testid }) => (
  <div className="mb-14" data-testid={testid}>
    <p className="text-xs uppercase tracking-[0.25em] text-gold mb-4">{overline}</p>
    <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight max-w-2xl">{title}</h2>
    {children && <p className="mt-5 text-base text-white/60 font-light max-w-xl leading-relaxed">{children}</p>}
  </div>
);
